// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.F5FPxr6guWQdyXqoBTCM {
  width: 100%;
  padding: 0 8px 8px;
  /* Widest a card is allowed to get. --columns and --gap are set inline from
     the measured column count; this one never changes. */
  --max-card-width: 227px;
}
.jBsRJR6zZRfRuNEar1rb {
  position: relative;
}
/* Every row shares the same geometry, so it comes from the container's custom
   properties rather than a per-row inline style — only translateY stays inline.
   Tracks are flexible and the cap lives on max-width, so cards can never grow
   wider than the container. The --columns and --gap fallbacks matter: those two
   arrive as inline styles from JS, and a missing --columns would invalidate
   grid-template-columns and stack every card into one column. */
.Xb3fv0ZzO4tWYkKRX0SS {
  position: absolute;
  top: 0;
  /* left + right with auto margins keeps the row centred once max-width kicks
     in; a fixed width: 100% would not. */
  left: 0;
  right: 0;
  margin: 0 auto;
  max-width: calc(var(--max-card-width) * var(--columns, 5) + var(--gap, 8px) * (var(--columns, 5) - 1));
  display: grid;
  grid-template-columns: repeat(var(--columns, 5), minmax(0, 1fr));
  gap: var(--gap, 8px);
  padding-bottom: var(--gap, 8px);
}
@media (orientation: portrait) {
  .F5FPxr6guWQdyXqoBTCM {
    padding: 0 0 8px;
  }
}
@media (min-width: 1025px) {
  .F5FPxr6guWQdyXqoBTCM {
    padding-bottom: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/VirtualizedGamesGrid/VirtualizedGamesGrid.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB;yDACuD;EACvD,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;;;;;gEAKgE;AAChE;EACE,kBAAkB;EAClB,MAAM;EACN;yCACuC;EACvC,OAAO;EACP,QAAQ;EACR,cAAc;EACd,sGAAsG;EACtG,aAAa;EACb,gEAAgE;EAChE,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".container {\n  width: 100%;\n  padding: 0 8px 8px;\n  /* Widest a card is allowed to get. --columns and --gap are set inline from\n     the measured column count; this one never changes. */\n  --max-card-width: 227px;\n}\n.viewport {\n  position: relative;\n}\n/* Every row shares the same geometry, so it comes from the container's custom\n   properties rather than a per-row inline style — only translateY stays inline.\n   Tracks are flexible and the cap lives on max-width, so cards can never grow\n   wider than the container. The --columns and --gap fallbacks matter: those two\n   arrive as inline styles from JS, and a missing --columns would invalidate\n   grid-template-columns and stack every card into one column. */\n.row {\n  position: absolute;\n  top: 0;\n  /* left + right with auto margins keeps the row centred once max-width kicks\n     in; a fixed width: 100% would not. */\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  max-width: calc(var(--max-card-width) * var(--columns, 5) + var(--gap, 8px) * (var(--columns, 5) - 1));\n  display: grid;\n  grid-template-columns: repeat(var(--columns, 5), minmax(0, 1fr));\n  gap: var(--gap, 8px);\n  padding-bottom: var(--gap, 8px);\n}\n@media (orientation: portrait) {\n  .container {\n    padding: 0 0 8px;\n  }\n}\n@media (min-width: 1025px) {\n  .container {\n    padding-bottom: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `F5FPxr6guWQdyXqoBTCM`,
	"viewport": `jBsRJR6zZRfRuNEar1rb`,
	"row": `Xb3fv0ZzO4tWYkKRX0SS`
};
export default ___CSS_LOADER_EXPORT___;
